import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("mql_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use((r) => r, (err) => {
  if (err?.response?.status === 503 && err.response.data?.maintenance) {
    window.dispatchEvent(new CustomEvent("mql:maintenance", { detail: err.response.data.detail }));
  }
  return Promise.reject(err);
});

export default api;

export const imgSrc = (url) => (url && url.startsWith("/api/") ? `${BACKEND_URL}${url}` : url);

export const fmtIDR = (n) =>
  new Intl.NumberFormat("id-ID", { style: "currency", currency: "IDR", maximumFractionDigits: 0 }).format(n || 0);
